import { trackEvent } from '@99designs/common/utils/platform';
import { DesignerLevel, DesignerSource } from '__generated__/types';

export enum Events {
    BRIEF_VIEWED = 'Project brief viewed',
    BRIEF_RESUMED = 'Project brief resumed',
    CLICKED_NEXT_BUTTON = 'Project brief next button clicked',
    CLICKED_SHOW_MORE_DESIGNERS_BUTTON = 'Project brief show more designers button clicked',
    DESIGNER_ADDED = 'Project brief designer added',
    DESIGNER_REMOVED = 'Project brief designer removed',
    DESIGNER_VIEWED = 'Project brief designer viewed',
    CLICKED_INVITE_DESIGNER_BUTTON = 'Project brief invite designer button clicked',
    CLICKED_MATCH_WITH_MORE_DESIGNERS_BUTTON = 'Project brief match with more designers button clicked',
    BUDGET_ENTERED = 'Project brief budget amount entered',
    CLICKED_EDIT_BUTTON = 'Project brief edit button clicked',
    BRIEF_ENTRY_VIEWED = 'Project brief entry page viewed',
    PROJECT_INVOICE_PAYMENT_SUCCESSFUL = 'Project invoice payment successful',
}

interface BriefEventProps {
    id: string;
}

interface ViewedProjectBriefEventProps extends BriefEventProps {
    page: 'AboutYou' | 'Details' | 'TimeAndBudget' | 'Summary' | 'InviteDesigners';
}

interface ViewedSquarespaceBriefEventProps extends BriefEventProps {
    page: 'SquarespaceDesigners' | 'SquarespaceDirect';
    initial_email_address: string;
}

type ViewedBriefEventProps = ViewedProjectBriefEventProps | ViewedSquarespaceBriefEventProps;

interface EditBriefEventProps extends BriefEventProps {
    page: 'AboutYou' | 'Details' | 'TimeAndBudget';
}

interface BriefEntryEventProps {
    user_id: number;
}

interface ProjectPaymentSuccessfulProps {
    profit: number;
    currency: string;
    exchangeRate: number;
    usdProfitInCents: number;
}

interface SentEventProps extends BriefEventProps {
    designer_count: number;
    project_ids: Array<number>;
    designer_ids: Array<number>;
    designer_names: Array<string>;
}

interface ShowMoreEventProps extends BriefEventProps {
    designers_per_page: number;
    total_designers: number;
}

interface DesignerEventProps extends BriefEventProps {
    relevant_ranking?: number;
    designer_level?: DesignerLevel;
    designer_name?: string;
    designer_id: number;
    designer_source?: DesignerSource;
}

interface BudgetEventProps extends BriefEventProps {
    input_type: 'textBoxField' | 'sliderField';
}

export function trackEditBriefEvent(params: EditBriefEventProps): void {
    trackEvent(Events.CLICKED_EDIT_BUTTON, params);
}

export function trackViewedBriefEvent(params: ViewedBriefEventProps): void {
    trackEvent(Events.BRIEF_VIEWED, params);
}

export function trackResumedBriefEvent(params: BriefEventProps): void {
    trackEvent(Events.BRIEF_RESUMED, params);
}

export function trackClickedNextButtonEvent(params: BriefEventProps): void {
    trackEvent(Events.CLICKED_NEXT_BUTTON, params);
}

export function trackClickedShowMoreDesignersEvent(params: ShowMoreEventProps) {
    trackEvent(Events.CLICKED_SHOW_MORE_DESIGNERS_BUTTON, params);
}

export function trackAddedDesignerEvent(params: DesignerEventProps) {
    trackEvent(Events.DESIGNER_ADDED, params);
}

export function trackRemovedDesignerEvent(params: DesignerEventProps) {
    trackEvent(Events.DESIGNER_REMOVED, params);
}

export function trackViewedDesignerEvent(params: DesignerEventProps) {
    trackEvent(Events.DESIGNER_VIEWED, params);
}

export function trackClickedInviteDesignerButtonEvent(params: BriefEventProps) {
    trackEvent(Events.CLICKED_INVITE_DESIGNER_BUTTON, params);
}
export function trackClickedMatchMoreDesignersButtonEvent(params: BriefEventProps) {
    trackEvent(Events.CLICKED_MATCH_WITH_MORE_DESIGNERS_BUTTON, params);
}

export function trackBudgetEvent(params: BudgetEventProps) {
    trackEvent(Events.BUDGET_ENTERED, params);
}

export function trackBriefEntryViewedEvent(params: BriefEntryEventProps): void {
    trackEvent(Events.BRIEF_ENTRY_VIEWED, params);
}

export function trackProjectPaymentSuccessful(params: ProjectPaymentSuccessfulProps): void {
    trackEvent(Events.PROJECT_INVOICE_PAYMENT_SUCCESSFUL, params);
}
